import { formatCurrency } from "@compass/core";
import { getPdfReportSpacing, PdfReportCss, PdfReportDataDisplay, PdfReportHeader, PdfReportSignBox } from "components";
import { MatchReportContributor, MatchReportContributorRow } from "generated/openApi";

export const ContributorHtml = (props: { report: MatchReportContributor }) => {
  const renderFilters = (contributorRow: MatchReportContributorRow) => {
    const dataDisplayLabelWidth = "200px";

    return (
      <div style={{ paddingBottom: getPdfReportSpacing("md") }}>
        <PdfReportDataDisplay
          label="Contributor"
          value={
            <>
              {contributorRow.contributor?.lastName}, {contributorRow.contributor?.firstName}
            </>
          }
          labelStyle={{ width: dataDisplayLabelWidth }}
        />

        <PdfReportDataDisplay
          label="Title"
          value={contributorRow.contributor?.currentTitle}
          labelStyle={{ width: dataDisplayLabelWidth }}
        />

        <PdfReportDataDisplay
          label="Employee ID"
          value={contributorRow.contributor?.employeeIdentification}
          labelStyle={{ width: dataDisplayLabelWidth }}
        />

        <PdfReportDataDisplay
          label="Partner"
          value={contributorRow.partner?.name}
          labelStyle={{ width: dataDisplayLabelWidth }}
        />

        <PdfReportDataDisplay
          label="Sub-Partner"
          value={contributorRow.subPartner?.name}
          labelStyle={{ width: dataDisplayLabelWidth }}
        />

        <PdfReportDataDisplay
          label="Partner Address"
          value={contributorRow.partner?.formattedAddress}
          labelStyle={{ width: dataDisplayLabelWidth }}
        />

        <PdfReportDataDisplay
          label="Report Period"
          value={
            <>
              {props.report.dateFrom && new Date(props.report.dateFrom).toLocaleDateString()} to{" "}
              {props.report.dateTo && new Date(props.report.dateTo).toLocaleDateString()}
            </>
          }
          labelStyle={{ width: dataDisplayLabelWidth }}
        />

        <PdfReportDataDisplay
          label="Status"
          value={props.report.reviewName}
          labelStyle={{ width: dataDisplayLabelWidth }}
        />
      </div>
    );
  };

  const renderConfirmText = () => {
    return (
      <div style={{ paddingBottom: getPdfReportSpacing("md") }}>
        I confirm that during this reporting period, the following is an accurate distribution of how my time and effort
        were expended:
      </div>
    );
  };

  const renderAmounts = (contributorRow: MatchReportContributorRow) => {
    const valueStyle: React.CSSProperties = { textAlign: "right" };
    return (
      <div style={{ paddingBottom: getPdfReportSpacing("md") }}>
        <PdfReportDataDisplay
          label="Salary"
          value={formatCurrency(contributorRow.amountSum)}
          valueStyle={{ ...valueStyle }}
        />

        <PdfReportDataDisplay
          label="Benefits"
          value={formatCurrency(contributorRow.benefitAmountSum)}
          valueStyle={{ ...valueStyle }}
        />

        <PdfReportDataDisplay
          label="Mileage"
          value={formatCurrency(contributorRow.milesAmountSum)}
          valueStyle={{ ...valueStyle }}
        />

        <div style={{ paddingBottom: getPdfReportSpacing("md") }}></div>

        <PdfReportDataDisplay
          label="Total Direct Cost"
          value={formatCurrency(contributorRow.totalDirectCost)}
          valueStyle={{ ...valueStyle }}
        />

        <PdfReportDataDisplay
          label="Total Indirect Cost"
          value={formatCurrency(contributorRow.totalIndirectCost)}
          valueStyle={{ ...valueStyle }}
        />

        <PdfReportDataDisplay
          label="Total"
          value={formatCurrency(contributorRow.total)}
          valueStyle={{ ...valueStyle }}
        />
      </div>
    );
  };

  const renderSignArea = () => {
    return (
      <div>
        <div style={{ paddingBottom: getPdfReportSpacing("md") }}>
          By signing this form, I hereby certify that the contribution above has not and will not be paid from federal
          funds and this contribution has not and will not be used as match for any other federally funded program. All
          contributions above were contributed in exclusive and direct benefit of the GEAR UP program.
        </div>

        <PdfReportSignBox label="Signature" />
        <PdfReportSignBox label="Print name" />
        <PdfReportSignBox label="Date" />
      </div>
    );
  };

  return (
    <>
      <PdfReportCss />
      <div>
        {props.report.contributorRows?.map((contributorRow) => (
          <div style={{ pageBreakAfter: "always" }}>
            <PdfReportHeader title={"Match Contributor Report"} tenantName={props.report.tenantName} />

            {renderFilters(contributorRow)}

            {renderConfirmText()}

            {renderAmounts(contributorRow)}

            {renderSignArea()}
          </div>
        ))}
      </div>
    </>
  );
};
